import { useDownloadFile } from "@/hooks/useDownloadFile/useDownloadFile";
import { useDownloadTranscription } from "@/hooks/useDownloadTranscription/useDownloadTranscription";
import { useShareLink } from "@/hooks/useShareLink/useShareLink";

import { useHandler as useHelpHandler } from "@/components/HelpButton/HelpButton.hooks";
import { formatToFilenameDate } from "@/helpers/date/date.helpers";
import { useCall } from "@/hooks/useCall/useCall";
import { useTrack } from "@/hooks/useTrack/useTrack";

export function useHandlers() {
  const { track } = useTrack();
  const { call } = useCall();

  const filename = `call_${call?.type.toLowerCase()}_${call?.id}_${formatToFilenameDate(new Date(call?.createdAt ?? ""))}`;

  const handleOnClickShare = useShareLink();
  const { downloadAudioFile: handleOnClickDownloadRecording } = useDownloadFile(
    filename ?? "recording.mp3"
  );
  const { downloadTranscription: handleOnClickDownloadTranscript } =
    useDownloadTranscription(filename ?? "transcription.txt");
  const handleOnClickFeeback = () => {
    track("assets_page_feedback_button_clicked");
  };
  const handleOnClickHelp = useHelpHandler();

  return {
    handleOnClickDownloadRecording,
    handleOnClickFeeback,
    handleOnClickShare,
    handleOnClickHelp,
    handleOnClickDownloadTranscript,
  };
}
